import React, { Component } from "react";
import "./App.css";
import LayoutComponent from './layout/LayoutComponent'

class App extends Component {
  render() {
    return (
      <LayoutComponent />
    );
  }
}

export default App;
